const API_BASE_URL =
  window.location.hostname === 'qtf.iniserve.com'
    ? 'https://qtf.iniserve.com'
    : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000');

/**
 * Resolve a visit site/selfie field to a browser-loadable image URL.
 */
export function resolveVisitImageSrc(detail, kind = 'site') {
  if (!detail) return null;

  const dataUrl =
    kind === 'site' ? detail.visit_photo_data_url : detail.selfie_data_url;
  const raw = kind === 'site' ? detail.visit_photo_path : detail.selfie_path;

  if (dataUrl) return dataUrl;
  if (raw == null || raw === '') return null;

  const s = String(raw).trim();
  if (!s) return null;
  if (s.startsWith('data:image')) return s;
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (s.startsWith('/')) {
    const base = API_BASE_URL.replace(/\/$/, '');
    return `${base}${s}`;
  }
  if (s.length >= 80) {
    const b64 = s.replace(/^data:image\/\w+;base64,/, '').replace(/\s/g, '');
    return b64 ? `data:image/jpeg;base64,${b64}` : null;
  }
  return null;
}

export function visitHasPhoto(detail, kind = 'site') {
  if (!detail) return false;
  if (kind === 'site') {
    return detail.has_visit_photo === true || !!resolveVisitImageSrc(detail, 'site');
  }
  return detail.has_selfie === true || !!resolveVisitImageSrc(detail, 'selfie');
}
